// extracted by mini-css-extract-plugin
module.exports = {"root":"Showcase_root__cT7IV","title":"Showcase_title__S5Ycn","gamebox":"Showcase_gamebox__eMQ8M","qrCode":"Showcase_qrCode__2Q4ZY"};